import { render, staticRenderFns } from "./certificadoDispositivo.vue?vue&type=template&id=bb4636e8&"
import script from "./certificadoDispositivo.vue?vue&type=script&lang=ts&"
export * from "./certificadoDispositivo.vue?vue&type=script&lang=ts&"
import style0 from "./certificadoDispositivo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports